import styled, { css } from 'styled-components';
export const Message = styled.div `
  ${({ theme: { findingSessionsText } }) => css `${findingSessionsText}`}
`;
export const Percentage = styled.div `
  margin-top: 2rem;
  ${({ theme: { findingSessionsPercentage } }) => css `${findingSessionsPercentage}`}
`;
export const Wrapper = styled.div `
  ${({ theme: { findingSessionsWrapper } }) => css `${findingSessionsWrapper}`}
`;
export const LoadingBarInner = styled.div `
  position: absolute;
  height: 100%;
  width: 0;
  border-radius: .5rem;
  display: block;
  left: 0;
  top: 0;
  transition: width 60s linear;
  background-color: #01ACEA;
  ${({ theme: { loadingBarInner } }) => css `${loadingBarInner}`}

  ${({ working }) => working && css `width: 85%;`}
  ${({ finished }) => finished && css `width: 100%;
    transition: width .4s linear;`}
`;
export const LoadingBar = styled.div `
  display: block;
  position: relative;
  height: 1rem;
  width: 100%;
  max-width: 30rem;
  border-radius: .5rem;
  background-color: #E9E8EF;
  margin-top: 1rem;

  ${({ theme: { loadingBarWrapper } }) => css `${loadingBarWrapper}`}
`;
export default {
    Message,
    Percentage,
    Wrapper,
    LoadingBarInner,
    LoadingBar,
};
